<template>
  <el-config-provider :locale="getGlobalI18n">
    <router-view :key="routerKey"></router-view>
  </el-config-provider>
  <!-- <cookieAccpet></cookieAccpet> -->
  <!-- 浮动右侧栏 -->
  <div class="right-bar-style" v-if="visibleAiIcon">
    <div class="flex flex-col">
      <!-- 客服 -->
      <div class="relative">
        <div class="bar-item flex items-center justify-center flex-col" @click="openChartWindow">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="bar-icon"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
          </svg>
          <div class="bar-text" style="text-align: center">AI助手</div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="visibleAiIcon">
    <chart-window id="AIChartWindow" class="chanrt-window-style" v-show="showChartWindow"
      @close="closeChartWindow"></chart-window>
  </div>
</template>

<script setup>
import { onMounted, reactive, provide, nextTick, computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useLogin } from "/@/store/login.js";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import ChartWindow from "/@/views/AI/components/ChartWindow.vue";
import { ChildRegister } from './utils/iframeCall.js';
import { useAiInteractive } from "./utils/aiInteractive.js";
const { messages, locale } = useI18n();
const route = useRoute();
const router = useRouter();
const loginStore = useLogin();

const showChartWindow = ref(false);


const openChartWindow = () => {
  const m_IsCloseChartWindow = sessionStorage.getItem('m_IsCloseChartWindow') || false;
  showChartWindow.value = true;
  const { openChartWindow } = useAiInteractive();
  if (!JSON.parse(m_IsCloseChartWindow)) {
    openChartWindow();
  } else {
    closeChartWindow();
  }
}
const closeChartWindow = () => {
  const {closeChartWindow } = useAiInteractive();
  closeChartWindow();
  showChartWindow.value = false;
};

let state = reactive({
  zh_key: 1,
  en_key: 2,
  isRouterAlive: true,
});

const visibleAiIcon = computed(() => {
  const userInfo = loginStore.getUserInfo();
  let isLogin = userInfo.Token ? true : false;
  if (window.globalConfig.CorpInfo.CorpFlag === 'NJLS' && isLogin) {
    return true
  }
  return false
})

let getGlobalI18n = computed(() => {
  return messages.value[locale.value];
});
let noFrame = computed(() => {
  if (typeof route.meta.noFrame === "undefined") return true;
  return route.meta.noFrame;
});
let routerKey = computed(() => {
  return `${route.path}?v=${Math.random()}`;
});
onMounted(() => {
  const m_IsCloseChartWindow = sessionStorage.getItem('m_IsCloseChartWindow') || false;
  if(JSON.parse(m_IsCloseChartWindow)){
    showChartWindow.value = true
  }
  const corpFlag = window.globalConfig.CorpFlag ?? null;
  const redirectPathMap = new Map([
    [
      "XJBY",
      {
        searchPath: "http://139.224.1.27:8099/",
        redirectPath: "https://shimge.xpump.net/",
      },
    ],
  ]);
  if (corpFlag) {
    if (redirectPathMap.has(corpFlag)) {
      const redirectPath = redirectPathMap.get(corpFlag).redirectPath;
      const searchPath = redirectPathMap.get(corpFlag).searchPath;
      let currentUrl = window.location.href;
      if (currentUrl.includes(searchPath)) {
        currentUrl = currentUrl.replace(searchPath, redirectPath);
        window.location.replace(currentUrl);
      }
    }
  }

  load_ISOCP_FontType();
  nextTick(() => {
    ChildRegister.registerNotifyFunction();
  });
  router.beforeEach((to, from, next) => {
    let routerName = [
      "Tel",
      "Email",
      "changePassword",
      "forgetPassword",
      "wechartuserBind",
    ];
    if (!routerName.includes(to.name)) {
      loginStore.preLoginPageRoute(to.fullPath);
    }
    next();
  });
});
const reload = () => {
  state.isRouterAlive = false;
  nextTick(() => {
    state.isRouterAlive = true;
  });
};

const load_ISOCP_FontType = () => {
  let isLoad = false;
  let PageAssetsConfig = window.pageConfig.PumpDetailPage.PageAssets ?? false;
  if (PageAssetsConfig) {
    isLoad = PageAssetsConfig.FontFamily.ISOCP;
  }
  if (!isLoad) return;
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = "/static/css/isocp/ISOCP.css"; // 替换为你的字体样式表路径
  document.head.appendChild(link);
};

provide("reload", reload);
</script>
<style lang="scss" scoped>
.right-bar-style {
  position: fixed;
  right: 60px;
  bottom: 128px;
  z-index: 50;

  .relative {
    position: relative;
  }

  .flex {
    display: flex;
  }

  .flex-col {
    flex-direction: column;
  }

  .items-center {
    align-items: center;
  }

  .justify-center {
    justify-content: center;
  }

  .bar-item {
    padding: 0.05rem;
    border-radius: 5px;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #fff;

    &:hover {
      background-color: #f0f0f0;
    }
  }

  .bar-text {
    color: #000;
    border-radius: 5px;
    padding: 5px 10px;
    font-size: 12px;
    text-align: center;
  }

  .bar-icon {
    width: 24px;
    height: 24px;
  }
}

.chanrt-window-style {
  position: fixed;
  right: 150px;
  bottom: 43px;
  z-index: 50;
  width: 440px;
  height: calc(80vh - 30px);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
}
</style>
